module.exports = __webpack_public_path__ + "media/toolkits/icon-1-tempscan-5c7a7cff.svg";